
export function HtmlBp(){

    return(

        <>
        <h1 className="html_gfg_heading">These are the <strong style={{textDecoration : 'underline', color : 'blue'}}>Top 7 </strong> recommended Main Projects that you can Do with this Project Ideas  </h1>


        <h4 className="des_bp_html">

        1. Do with your own<strong> Main </strong>knowing Concepts. <br/>
        2. Aks GPT to your doubt Clarification.  <br/>
        3. Enough projects to do this which we are recommended.
        </h4>

        {/* <-----------------------------------------1------------------------------------------*/}
        <div className="container_html_bp_links">

        <p className="vid">Project 1: Creating a Personal Portfolio Page


        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val1, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------2------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid">  Project 2: Building a Simple Blog Layout


        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val2, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------3------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 3: Designing a Landing Page


        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val3, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------4------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 4: Crafting an eCommerce Page

        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val4, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div> 


        {/* <-----------------------------------------5------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 5: Developing a Recipe Page


        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val5, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------6------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 6: Building a Small Business Homepage 


        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val6, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------7------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 7: Creating an Event Invitation Page

        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val7, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div>

        </>
    )
}

export default HtmlBp;